import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex overflow-hidden items-center gap-2" }

import { EmailShortMessage } from '@/inbox/composition';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailShortMessage',
  props: {
    message: null,
    isUnread: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["whitespace-nowrap overflow-hidden overflow-ellipsis", 
				__props.isUnread
					? 'text-inbox-gray-theme-600 font-medium'
					: 'text-inbox-gray-theme-600 font-light'
			])
    }, [
      _createTextVNode(_toDisplayString(__props.message.content.subject) + " ", 1),
      _createElementVNode("span", {
        class: _normalizeClass(["ml-2", 
					__props.isUnread
						? 'font-light text-inbox-gray-theme-400'
						: 'text-inbox-gray-theme-400 font-light'
				])
      }, _toDisplayString(__props.message.content.body_preview), 3)
    ], 2)
  ]))
}
}

})